import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  OverlayTrigger, Tooltip,
  DropdownButton, MenuItem,
} from 'react-bootstrap';
import Fa from 'react-fontawesome';
import {
  each, range, filter, values, keyBy, orderBy, slice,
  find, map, intersection, concat, difference,
} from 'lodash';
import { format } from '../../../../components/money-display';

import NumberDisplay from '../../../../components/number-display';
import Shimmer from '../../../../components/shimmer';
import {
  getWinLossOpportunities,
  getWinLossAccounts,
  getWinLossLoaded,
  getWinLossFeedbackLoaded,
  getWinLossTotalExclude,
} from '../../../Dashboard/DashboardReducer';
import CollectorStats from './CollectorStats';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';


import StrengthModel from './StrengthModal';

import styles from './styles.css';


const MAX_ITEMS = 10;
const STRONG_TAB = 'strong';
const WEAK_TAB = 'weak';

const SHOW_ALL = {
  [STRONG_TAB]: false,
  [WEAK_TAB]: false,
};

class SideBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: STRONG_TAB,
      stats: {
        [STRONG_TAB]: [],
        [WEAK_TAB]: [],
      },
      showAll: { ...SHOW_ALL },
      points: {},
      showModal: false,
      currentStrength: null,
    };
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalExited = this.handleModalExited.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loaded && this.props.loaded !== nextProps.loaded) {
      this.calculateData(nextProps.objects);
    } else if (this.props.loaded && this.props.totalExclude !== nextProps.totalExclude) {
      this.calculateData(nextProps.objects);
    }
  }

  calculateData(objects) {
    const { isAccount } = this.props;
    const stats = {
      [STRONG_TAB]: {}, // indexed by label!
      [WEAK_TAB]: {}, // indexed by label!
    };
    const points = {
      noRequestNoFeedback: {
        count: 0, point: 0, amount: 0, ids: [],
      },
      requestedNoFeedback: {
        count: 0, point: 0, amount: 0, ids: [],
      },
      requesting: {
        count: 0, point: 0, amount: 0, ids: [],
      },
      requested: {
        count: 0, point: 0, amount: 0, ids: [], // at least one contact, no one in out reach
      },
      haveFeedback: {
        count: 0, point: 0, amount: 0, ids: [],
      },
      nonResponsive: {
        count: 0, point: 0, amount: 0, ids: [],
      },
      excluded: {
        count: 0, point: 0, amount: 0, ids: [],
      },
      percentage: 0,
      totalExclude: 0,
    };
    const amountKey = isAccount ? 'ttm' : 'amount';

    each(objects, (object) => {
      const objId = isAccount ? object.account_id : object.opportunity_id;

      /*
      if (isAccount && object.customer_status !== 'current') {
        points.excluded.count += 1;
        points.excluded.amount += object[amountKey] || 0;
        points.excluded.ids.push(objId);
        points.totalExclude += 1;
        return;
      }
      */

      if (object.excluded) {
        points.excluded.count += 1;
        points.excluded.amount += object[amountKey] || 0;
        points.excluded.ids.push(objId);
        points.totalExclude += 1;
        return;
      }

      const allFeedbacks = (isAccount ? object.eighteen_month_feedbacks : object.feedbacks) || [];
      if (object.has_feedbacks) {
        points.haveFeedback.count += 1;
        points.haveFeedback.ids.push(objId);
        points.haveFeedback.amount += object[amountKey] || 0;
        points.haveFeedback.point += 2;
      } else if (object.in_outreach) {
        points.requesting.count += 1;
        points.requesting.ids.push(objId);
        points.requesting.amount += object[amountKey] || 0;
        points.requesting.point += 1;
      } else if (object.has_non_responsive) {
        points.nonResponsive.count += 1;
        points.nonResponsive.ids.push(objId);
        points.nonResponsive.amount += object[amountKey] || 0;
      } else if (object.requested_no_outreach) {
        points.requested.count += 1;
        points.requested.ids.push(objId);
        points.requested.amount += object[amountKey] || 0;
        points.requested.point += 1;
      } else if (object.no_request_no_feedback) {
        points.noRequestNoFeedback.count += 1;
        points.noRequestNoFeedback.ids.push(objId);
        points.noRequestNoFeedback.amount += object[amountKey] || 0;
      }

      if (allFeedbacks.length) {
        const feedbacks = values(keyBy(filter(allFeedbacks, { is_client: true }), 'label')); // only client feedbacks

        each(feedbacks, (feedback) => {
          const { label } = feedback;
          let key = null;
          if (isAccount) {
            if (feedback.experience_condition === 'Positive') {
              key = STRONG_TAB; // for now
            } else if (feedback.experience_condition === 'Negative') {
              key = WEAK_TAB; // for now
            }
          } else if (object.stage === 'Won') {
            key = STRONG_TAB;
          } else if (object.stage === 'Lost' || object.stage === 'No Decision') {
            key = WEAK_TAB;
          }
          if (key) {
            if (!stats[key][label]) {
              stats[key][label] = {
                label,
                amount: 0,
                count: 0,
                items: [],
                type: key === STRONG_TAB ? 'Strength' : 'Weakness', // strength / weakness
                client: feedback.vendor_name,
              };
            }
            stats[key][label].count += 1;
            stats[key][label].amount += object[amountKey] || 0;
            const id = isAccount ? object.account_id : object.opportunity_id;
            stats[key][label].items.push({ id: `${feedback.id}|${id}`, feedback, object });
          }
        });
      }
    });
    each(stats, (stat, type) => {
      stats[type] = orderBy(values(stat), ['amount'], ['desc']);
    });

    const totalPoint = points.noRequestNoFeedback.count + points.requestedNoFeedback.count + points.haveFeedback.count;
    if (totalPoint > 0) {
      points.percentage = points.haveFeedback.point / (totalPoint * 2);
    }
    this.setState({ stats, points, showAll: { ...SHOW_ALL } });
  }

  handleTabSelect(tab) {
    this.setState({ tab });
  }

  showStats(currentStrength) {
    this.setState({ currentStrength, showModal: true });
  }

  showMore(type, value) {
    this.setState({ showAll: { ...this.state.showAll, [type]: value } });
  }

  handleModalClose() {
    this.setState({ showModal: false });
  }

  handleModalExited() {
    this.setState({ currentStrength: null });
  }


  renderLoading() {
    return (
      <div className={styles.shimmers}>
        <div className={styles.topChart}>
          <div className={styles.boxInner}>
            <div>
              <div className={styles.chartTitle}><Shimmer value="XXXXXXXXXXXXXXXXXXX" /></div>
              <nobr className={styles.chartNums}>
                <span className={styles.chartMainNum}><Shimmer value="XXXXX" /></span>
              </nobr>
            </div>
          </div>
        </div>
        <div className={styles.boxInner}>
          <div style={{ paddingBottom: 10 }}>
            <Shimmer value="XXXXXXXXXX" />&nbsp;&nbsp;&nbsp;<Shimmer value="XXXXXXXXXXXX" />
          </div>
          {range(5).map(r => (
            <div className={styles.stats} key={r}>
              <div className={styles.statsName}><Shimmer value="XXX" full /></div>
              <div className={styles.subStats}><Shimmer value="XXX" full /></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderMoney(value) {
    const { organization } = this.props;
    let suffix = '';
    let symbol = '';
    if (organization) {
      suffix = organization.currency_suffix;
      symbol = organization.currency_symbol;
    }
    return format(value, true, 2, symbol, suffix);
  }

  renderList(type) {
    const { stats, showAll } = this.state;
    const { isAccount } = this.props;
    const typeStats = stats[type];
    let label = type === STRONG_TAB ? 'strengths' : 'weakness';
    if (isAccount) {
      label = type === STRONG_TAB ? 'positives' : 'negatives';
    }
    if (!typeStats || typeStats.length === 0) {
      return (
        <div className="well" style={{ margin: 0 }}>No {label} found</div>
      );
    }
    const shouldShowAll = showAll[type] === true;
    const items = shouldShowAll ? typeStats : slice(typeStats, 0, MAX_ITEMS);
    const hasMore = items.length < typeStats.length;
    const hasLess = items.length > MAX_ITEMS;
    const total = typeStats.length;

    return (
      <div>
        <table className="table table-condensed table-striped" style={{ margin: 0 }}>
          <thead className={styles.innerContent}>
            <tr>
              <th>&nbsp;</th>
              <th className="text-capitalize">{label}</th>
              <th className="text-right">Influenced</th>
              <th className="text-right">{(isAccount ? 'Accounts' : 'Deals')}</th>
            </tr>
          </thead>
          <tbody className={styles.innerContent}>
            {items.map((typeStat, i) => (
              <tr key={typeStat.label}>
                <td className="text-right">{(i + 1)}.</td>
                <td>
                  <a href="" onClick={(e) => { e.preventDefault(); this.showStats(typeStat); }}>
                    {typeStat.label}
                  </a>
                </td>
                <td className="text-right">
                  {this.renderMoney(typeStat.amount)}
                </td>
                <td className="text-right">
                  <NumberDisplay value={typeStat.count} precision={0} />
                </td>
              </tr>
            ))}
          </tbody>
          {(hasMore || hasLess) &&
            <tfoot className={styles.innerContent}>
              <tr>
                <th className="text-center" colSpan={4}>
                  {hasMore &&
                    <a href="" onClick={(e) => { e.preventDefault(); this.showMore(type, true); }}>
                      show all <NumberDisplay value={total} precision={0} suffix={label} suffixIsUnit /> <Fa name="chevron-down" />
                    </a>
                  }
                  {hasLess &&
                    <a href="" onClick={(e) => { e.preventDefault(); this.showMore(type, false); }}>
                      show only top <NumberDisplay value={MAX_ITEMS} precision={0} suffix={label} suffixIsUnit /> <Fa name="chevron-up" />
                    </a>
                  }
                </th>
              </tr>
            </tfoot>
          }
        </table>
      </div>
    );
  }

  renderChart() {
    const { isAccount, objects } = this.props;
    const { points } = this.state;

    const noRequestNoFeedback = points.noRequestNoFeedback || { count: 0, amount: 0 };
    const requested = points.requested || { count: 0, amount: 0 };
    const requesting = points.requesting || { count: 0, amount: 0 };
    const nonResponsive = points.nonResponsive || { count: 0, amount: 0 };
    const haveFeedback = points.haveFeedback || { count: 0, amount: 0 };
    const excluded = points.excluded || { count: 0, amount: 0 };

    const totalRecords = objects.length;
    const totalAmount = noRequestNoFeedback.amount + requested.amount + requesting.amount + nonResponsive.amount + haveFeedback.amount + excluded.amount;

    // const totalRecords = noRequestNoFeedback.count + requesting.count + requested.count + haveFeedback.count + excluded.count;
    // const totalAmount = noRequestNoFeedback.amount + requesting.amount + requested.amount + haveFeedback.amount + excluded.amount;


    const totalPoint = noRequestNoFeedback.point + requested.point + haveFeedback.point;

    const noRequestNoFeedbackPercentage = totalRecords !== 0 ? (noRequestNoFeedback.count / totalRecords) * 100 : 0;
    const requestedPercentage = totalRecords !== 0 ? (requested.count / totalRecords) * 100 : 0;
    const requestingPercentage = totalRecords !== 0 ? (requesting.count / totalRecords) * 100 : 0;
    const haveFeedbackPercentage = totalRecords !== 0 ? (haveFeedback.count / totalRecords) * 100 : 0;
    const excludedPercentage = totalRecords !== 0 ? (excluded.count / totalRecords) * 100 : 0;
    const nonResponsivePercentage = totalRecords !== 0 ? (nonResponsive.count / totalRecords) * 100 : 0;

    const { totalExclude } = points;
    const header = 'Feedback Progress';
    const objectType = isAccount ? 'Accounts' : 'Opportunities';

    const tip = (
      <Tooltip id="profile-stregth" className={styles.tooltip}>
        <div>
          <h2>{header}</h2>
          <table className="table table-condensed text-left">
            <thead>
              <tr>
                <th>{isAccount ? 'Current Customers' : 'Opportunities'}</th>
                <th className="text-right">Count</th>
                {!isAccount && <th className="text-right">Percent</th>}
                <th className="text-right">Amount</th>
                {isAccount && <th className="text-right">Point</th>}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="text-uppercase">Feedback</div>
                  <div><em>{objectType} with feedback</em></div>
                </td>
                <td className="text-right"><NumberDisplay value={haveFeedback.count} precision={0} /></td>
                {!isAccount && <td className="text-right"><NumberDisplay value={haveFeedbackPercentage} precision={1} suffix="%" /></td>}
                <td className="text-right">{this.renderMoney(haveFeedback.amount)}</td>
                {isAccount && <td className="text-right"><NumberDisplay value={haveFeedback.point} precision={0} /></td>}
              </tr>
              <tr>
                <td>
                  <div className="text-uppercase">Requesting</div>
                  <div><em>{objectType} with one or more contacts in outreach for feedback</em></div>
                </td>
                <td className="text-right"><NumberDisplay value={requesting.count} precision={0} /></td>
                {!isAccount && <td className="text-right"><NumberDisplay value={requestingPercentage} precision={1} suffix="%" /></td>}
                <td className="text-right">{this.renderMoney(requesting.amount)}</td>
                {isAccount && <td className="text-right"><NumberDisplay value={requesting.point} precision={0} /></td>}
              </tr>

              <tr>
                <td>
                  <div className="text-uppercase">No response</div>
                  <div><em>{objectType} at least one contact went through all the survey collector steps and did not provide feedback</em></div>
                </td>
                <td className="text-right"><NumberDisplay value={nonResponsive.count} precision={0} /></td>
                {!isAccount && <td className="text-right"><NumberDisplay value={nonResponsivePercentage} precision={1} suffix="%" /></td>}
                <td className="text-right">{this.renderMoney(nonResponsive.amount)}</td>
                {isAccount && <td className="text-right"><NumberDisplay value={nonResponsive.point} precision={0} /></td>}
              </tr>


              <tr>
                <td>
                  <div className="text-uppercase">Submitted</div>
                  <div><em>{objectType} with one or more contacts waiting to start feedback requests</em></div>
                </td>
                <td className="text-right"><NumberDisplay value={requested.count} precision={0} /></td>
                {!isAccount && <td className="text-right"><NumberDisplay value={requestedPercentage} precision={1} suffix="%" /></td>}
                <td className="text-right">{this.renderMoney(requested.amount)}</td>
                {isAccount && <td className="text-right"><NumberDisplay value={requested.point} precision={0} /></td>}
              </tr>
              
              <tr>
                <td>
                  <div className="text-uppercase">Excluded</div>
                  <div><em>{objectType} excluded from feedback requests</em></div>
                </td>
                <td className="text-right"><NumberDisplay value={excluded.count} precision={0} /></td>
                {!isAccount && <td className="text-right"><NumberDisplay value={excludedPercentage} precision={1} suffix="%" /></td>}
                <td className="text-right">{this.renderMoney(excluded.amount)}</td>
                {isAccount && <td className="text-right">0</td>}
              </tr>


              <tr>
                <td>
                  <div className="text-uppercase">No Requests</div>
                  <div><em>{objectType} with no requests for feedback</em></div>
                </td>
                <td className="text-right"><NumberDisplay value={noRequestNoFeedback.count} precision={0} /></td>
                {!isAccount && <td className="text-right"><NumberDisplay value={noRequestNoFeedbackPercentage} precision={1} suffix="%" /></td>}
                <td className="text-right">{this.renderMoney(noRequestNoFeedback.amount)}</td>
                {isAccount && <td className="text-right"><NumberDisplay value={noRequestNoFeedback.point} precision={0} /></td>}
              </tr>
              
              
              
              
            </tbody>
            <tfoot>
              <tr>
                <th className="text-right">Total:</th>
                <th className="text-right">
                  <NumberDisplay value={totalRecords} precision={0} />
                </th>
                {!isAccount && <th className="text-right">100%</th>}
                <th className="text-right">
                  {this.renderMoney(totalAmount)}
                </th>
                {isAccount && 
                  <th className="text-right">
                    <nobr>
                      <NumberDisplay value={totalPoint} precision={0} /> of <NumberDisplay value={(totalRecords * 2)} precision={0} />
                    </nobr>
                  </th>
                }
              </tr>
            </tfoot>
          </table>
          {!isAccount &&
            <p>
              The numbers in the table are based on your current filter settings and display the status of feedback requests by opportunity.
            </p>
          }
          {isAccount &&
            <p>
              The Experience Profile Strength metric is an indicator of how well you are using TruVoice Automation to capture feedback from your current customers. 
              An EPS score of 100% indicates 100% of your customers have provided feedback on their experience with you within the past 6 months. 
              Feedback older than 6 months is considered &ldquo;outdated&rdquo; and not counted when calculating your EPS score.
            </p>
          }
          {isAccount && totalExclude > 0 &&
            <p>Note: <NumberDisplay value={totalExclude} precision={0} suffix="past account" suffixIsUnit /> have been excluded.</p>
          }
        </div>
      </Tooltip>
    );
    
    const noRequestTips = (<Tooltip id="no-request">{objectType} with no requests for feedback</Tooltip>);
    const requestingTips = (<Tooltip id="requesting">{objectType} with one or more contacts in outreach for feedback</Tooltip>);
    const submittedTips = (<Tooltip id="submitted">{objectType} with one or more contacts waiting to start feedback requests</Tooltip>);
    const feedbackTips = (<Tooltip id="feedback">{objectType} with feedback</Tooltip>);
    const excludedTips = (<Tooltip id="feedback">{objectType} excluded from feedback requests.</Tooltip>);
    const nonResponsiveTips = (<Tooltip id="non-responsive">{objectType} with at least one contact went through all the survey collector steps and did not provide feedback.</Tooltip>);
    const totalTips = (<Tooltip id="total">Total {objectType}.</Tooltip>);
    

    let noRequestNoFeedbackHeader = (<OverlayTrigger trigger={['focus', 'hover']} placement="top" overlay={noRequestTips}><nobr>No requests</nobr></OverlayTrigger>);
    let requestingHeader = (<OverlayTrigger trigger={['focus', 'hover']} placement="top" overlay={requestingTips}><nobr>Requesting</nobr></OverlayTrigger>);
    let requestedHeader = (<OverlayTrigger trigger={['focus', 'hover']} placement="top" overlay={submittedTips}><nobr>Submitted</nobr></OverlayTrigger>);
    let haveFeedbackHeader = (<OverlayTrigger trigger={['focus', 'hover']} placement="top" overlay={feedbackTips}><nobr>Has Feedback</nobr></OverlayTrigger>);
    let excludedHeader = (<OverlayTrigger trigger={['focus', 'hover']} placement="top" overlay={excludedTips}><nobr>Excluded</nobr></OverlayTrigger>);
    let nonResponsiveHeader = (<OverlayTrigger trigger={['focus', 'hover']} placement="top" overlay={nonResponsiveTips}><nobr>No response</nobr></OverlayTrigger>);
    let totalHeader = (<OverlayTrigger trigger={['focus', 'hover']} placement="top" overlay={totalTips}><nobr>Total</nobr></OverlayTrigger>);
    


    if (noRequestNoFeedback.ids && noRequestNoFeedback.ids.length > 0) {
      noRequestNoFeedbackHeader = (
        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            this.props.requestShowObjects(noRequestNoFeedback.ids, 'No requests');
          }}
          className={styles.anchor}
        >
          {noRequestNoFeedbackHeader}
        </a>
      );
    }
    if (requesting.ids && requesting.ids.length > 0) {
      requestingHeader = (
        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            this.props.requestShowObjects(requesting.ids, 'No requests');
          }}
          className={styles.anchor}
        >
          {requestingHeader}
        </a>
      );
    }
    if (haveFeedback.ids && haveFeedback.ids.length > 0) {
      haveFeedbackHeader = (
        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            this.props.requestShowObjects(haveFeedback.ids, 'Has Feedback');
          }}
          className={styles.anchor}
        >
          {haveFeedbackHeader}
        </a>
      );
    }
    if (excluded.ids && excluded.ids.length > 0) {
      excludedHeader = (
        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            this.props.requestShowObjects(excluded.ids, 'Excluded', true);
          }}
          className={styles.anchor}
        >
          {excludedHeader}
        </a>
      );
    }
    if (requested.ids && requested.ids.length > 0) {
      requestedHeader = (
        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            this.props.requestShowObjects(requested.ids, 'Submitted');
          }}
          className={styles.anchor}
        >
          {requestedHeader}
        </a>
      );
    }

    if (nonResponsive.ids && nonResponsive.ids.length > 0) {
      nonResponsiveHeader = (
        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            this.props.requestShowObjects(nonResponsive.ids, 'No response');
          }}
          className={styles.anchor}
        >
          {nonResponsiveHeader}
        </a>
      );
    }

    if (totalRecords > 0) {
      totalHeader = (
        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            this.props.requestShowObjects(map(objects, isAccount ? 'account_id' : 'opportunity_id'), 'Total');
          }}
          className={styles.anchor}
        >
          {totalHeader}
        </a>
      );
    }

    return (
      <div key="chart" className={styles.topChart}>
        <div className={styles.boxInner}>
          <div>
            <OverlayTrigger trigger={['focus', 'hover']} placement="right" overlay={tip}>
              <div className={styles.chartTitle}>Feedback Progress</div>
            </OverlayTrigger>
            <table className="table table-condensed" styles={{ margin: 0 }}>
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th className="text-right">Count</th>
                  <th className="text-right">Percentage</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {haveFeedbackHeader}
                  </td>
                  <td className="text-right"><NumberDisplay value={haveFeedback.count} precision={0} /></td>
                  <td className="text-right"><NumberDisplay value={haveFeedbackPercentage} suffix="%" precision={1} /></td>
                </tr>
                <tr>
                  <td>
                    {requestingHeader}
                  </td>
                  <td className="text-right"><NumberDisplay value={requesting.count} precision={0} /></td>
                  <td className="text-right"><NumberDisplay value={requestingPercentage} suffix="%" precision={1} /></td>
                </tr>

                <tr>
                  <td>
                    {nonResponsiveHeader}
                  </td>
                  <td className="text-right"><NumberDisplay value={nonResponsive.count} precision={0} /></td>
                  <td className="text-right"><NumberDisplay value={nonResponsivePercentage} suffix="%" precision={1} /></td>
                </tr>

                <tr>
                  <td>
                    {requestedHeader}
                  </td>
                  <td className="text-right"><NumberDisplay value={requested.count} precision={0} /></td>
                  <td className="text-right"><NumberDisplay value={requestedPercentage} suffix="%" precision={1} /></td>
                </tr>

                <tr>
                  <td>
                    {excludedHeader}
                  </td>
                  <td className="text-right"><NumberDisplay value={excluded.count} precision={0} /></td>
                  <td className="text-right"><NumberDisplay value={excludedPercentage} suffix="%" precision={1} /></td>
                </tr>
                
                <tr>
                  <td>
                    {noRequestNoFeedbackHeader}
                  </td>
                  <td className="text-right"><NumberDisplay value={noRequestNoFeedback.count} precision={0} /></td>
                  <td className="text-right"><NumberDisplay value={noRequestNoFeedbackPercentage} suffix="%" precision={1} /></td>
                </tr>

                <tr>
                  <td>
                    {totalHeader}
                  </td>
                  <td className="text-right"><NumberDisplay value={totalRecords} precision={0} /></td>
                  <td className="text-right">100%</td>
                </tr>

              </tbody>
            </table>
            <div className={styles.tipTrigger}>
              <OverlayTrigger trigger={['focus', 'hover']} placement="right" overlay={tip}>
                <Fa name="ellipsis-h" />
              </OverlayTrigger>
            </div>
          </div>
          
        </div>
      </div>
    );
  }

  renderContent() {
    const { tab } = this.state;
    const { loaded, isAccount, collectors } = this.props;
    const strengthLabel = isAccount ? 'Positives' : 'Strengths';
    const weakLabel = isAccount ? 'Negatives' : 'Weaknesses';
    const hasMultipleCollectors = collectors.length > 1;
    let activeLabel = 'select stats type';
    const isStandardTab = (tab === STRONG_TAB || tab === WEAK_TAB);
    let activeCollector = null;
    if (isStandardTab) {
      activeLabel = tab === STRONG_TAB ? strengthLabel : weakLabel;
    } else {
      activeCollector = find(collectors, { collector_id: tab });
      activeLabel = 'Feedback Statistics';
    }

    return [
      this.renderChart(),
      (
        <div key="list">
          <div className={styles.controls}>
            <DropdownButton
              onSelect={this.handleTabSelect}
              bsStyle="default"
              block
              title={<span>Show: {activeLabel}</span>}
              id="stats-filter"
              disabled={!loaded}
            >
              {hasMultipleCollectors && <MenuItem header>{strengthLabel} &amp; {weakLabel}:</MenuItem>}
              <MenuItem disabled={!loaded} eventKey={STRONG_TAB} active={tab === STRONG_TAB}>
                {hasMultipleCollectors && <span>&nbsp;<Fa name="plus-circle" />&nbsp;</span>} {strengthLabel}
              </MenuItem>
              <MenuItem disabled={!loaded} eventKey={WEAK_TAB} active={tab === WEAK_TAB}>
                {hasMultipleCollectors && <span>&nbsp;<Fa name="minus-circle" />&nbsp;</span>} {weakLabel}
              </MenuItem>
              {hasMultipleCollectors && <MenuItem header>Feedback Statistics:</MenuItem>}
              {collectors.map((collector) => {
                return (
                  <MenuItem disabled={!loaded} key={collector.collector_id} eventKey={collector.collector_id} active={tab === collector.collector_id}>
                    {hasMultipleCollectors && <span>&nbsp;<Fa name="caret-right" />&nbsp;</span>} {(hasMultipleCollectors ? collector.collector_name : 'Feedback Statistics')}
                  </MenuItem>
                );
              })}
            </DropdownButton>
          </div>
          {isStandardTab &&
            <div className={styles.boxInner}>
              {!loaded && this.renderLoading()}
              {loaded && this.renderList(tab)}
            </div>
          }
          {!isStandardTab &&
            <div className={styles.boxInner}>
              {hasMultipleCollectors && activeCollector !== null && <div><strong>Collector: {activeCollector.collector_name}</strong></div>}
              <div>
                {activeCollector !== null &&
                  <CollectorStats
                    key={activeCollector.collector_id}
                    collector={activeCollector}
                    requestFetchCollectorStats={this.props.requestFetchCollectorStats}
                  />
                }
              </div>
            </div>
          }
        </div>
      ),
    ]
  }

  render() {
    const { loaded, isAccount } = this.props;

    return (
      <div className={styles.box}>
        {!loaded && this.renderLoading()}
        {loaded && this.renderContent()}
        <StrengthModel
          isAccount={isAccount}
          stregth={this.state.currentStrength}
          show={this.state.showModal}
          onClose={this.handleModalClose}
          onExited={this.handleModalExited}
        />
      </div>
    );
  }
}

SideBox.propTypes = {
  loaded: PropTypes.bool,
  isAccount: PropTypes.bool,
  objects: PropTypes.arrayOf(PropTypes.shape({})),
  totalExclude: PropTypes.number,
  collectors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  requestFetchCollectorStats: PropTypes.func,
  requestShowObjects: PropTypes.func,
  organization: PropTypes.shape({
    currency_suffix: PropTypes.string,
    currency_symbol: PropTypes.string,
  }).isRequired,
};
SideBox.defaultProps = {
  isAccount: false,
  objects: [],
  loaded: false,
  totalExclude: 0,
  requestFetchCollectorStats: () => {},
  requestShowObjects: () => {},
};

SideBox.contextTypes = {
  router: PropTypes.shape({}),
};

function mapStateToProps(state, ownProps) {
  return {
    objects: ownProps.isAccount ? getWinLossAccounts(state) : getWinLossOpportunities(state),
    loaded: getWinLossLoaded(state) && getWinLossFeedbackLoaded(state),
    totalExclude: getWinLossTotalExclude(state),
    organization: getUserCurrentOrganization(state),
  };
}

export default connect(mapStateToProps)(SideBox);
